import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { breakWord, capitalizeFirstLetter, formateDate, showStatus, TrimText } from "../../../../utils/commonfunction";
import * as inquiryServices from "../../services/inquiry.services";
import { useTranslation } from "react-i18next";

const InquiryView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard" },
    { title: t("Inquiries"), url: "/admin/inquiry/list/1" },
    { title: t("admin.faq.link_view"), url: "" },
  ];

  useEffect(() => {
    inquiryServices
      .Details({ id: params.id })
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("Inquiries View")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table  table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>{t("Name")} </th>
                          {/* <td className="text-capitalize">{showdefault && showdefault?.name ? showdefault.name : "N/A"}</td> */}
                          <td className="text-capitalize">{
                          showdefault?.role==='business'?
                          showdefault?.createdBy[0]?.business_name ? capitalizeFirstLetter(TrimText(showdefault.createdBy[0].business_name, 40)) : showdefault?.createdBy[0]?.fullName ? capitalizeFirstLetter(TrimText(showdefault.createdBy[0].fullName, 40)) : "N/A"
                          : capitalizeFirstLetter(TrimText(showdefault.name, 40)) 
                          }</td>
                        </tr>
                        <tr>
                          <th>{t("Email")} </th>
                          <td className="text-capitalize">{showdefault && showdefault?.email ? showdefault.email : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Role")}</th>
                          <td className="text-capitalize">{showdefault.role}</td>
                        </tr>
                        {showdefault.role && showdefault.role !== "user" && (
                          <tr>
                            <th>{t("Issue Type")}</th>
                            <td className="text-capitalize">{showdefault && showdefault?.issueType ? showdefault.issueType : "N/A"}</td>
                          </tr>
                        )}
                        <tr>
                          <th>Message</th>
                          <td className="text-capitalize">{showdefault && showdefault?.message ? showdefault.message : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Created Date")}</th>
                          <td>{showdefault && showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Modified Date")}</th>
                          <td>{showdefault && showdefault?.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InquiryView;
